import { render, staticRenderFns } from "./FormContainer.vue?vue&type=template&id=00f5b547&scoped=true"
import script from "./FormContainer.vue?vue&type=script&lang=js"
export * from "./FormContainer.vue?vue&type=script&lang=js"
import style0 from "./FormContainer.vue?vue&type=style&index=0&id=00f5b547&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f5b547",
  null
  
)

export default component.exports